import React from 'react';
import '../../src/styles/Home.css';
import ProductCard from '../components/ProductCard';
import logo from '../assets/logo.png';
import ream from '../assets/ream.jpg';
import box from '../assets/box.jpg';
import multiple from '../assets/multiple.jpg';
import { Link } from 'react-router-dom';
// import ProductPage from './ProductPage';

const products = [
  { id: 1, name: 'Letter size: 8.5" x 11"', image: ream, price: '$8.19', description: '500 sheets of reliable, high-volume paper' },
  { id: 2, name: 'Legal size: 8.5" x 14"', image: box, price: '$10.99', description: 'High-quality legal size paper' },
  { id: 3, name: 'Tabloid size: 11" x 17"', image: multiple, price: '$15.49', description: 'Tabloid size paper for larger prints' },
];

const Home = () => {
  return (
    <div className="home">
      <header className="landing">
        <img src={logo} alt="PaperForLess Logo" className="logo" />
        <h1>PaperForLess</h1>
        <p>Your one-stop shop for high-quality paper products.</p>
        <a href="/quote" className="cta-btn">Request a Quote</a>
      </header>

      <section className="products">
        <h2>Our Products</h2>
        <div className="product-list">
          {products.map(product => (
            // <ProductCard key={product.id} product={product} />
            // <Link to={`/products/${product.id}`} key={product.id}> {/* Use Link for routing */}
            //   <ProductCard product={product} />
            // </Link>
            <Link
              to={`/products/${product.id}`}
              state={{ product }}
              key={product.id}
            >
              <ProductCard product={product} />
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
